import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import Item from "components/common/plans/item";
import Typography from "components/common/Typography";
import { Bookmarkplans } from "components/features/library/Bookmark/Bookmark";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";

function TopSuggestedPlans() {
  const bookmarkedPlanList: any = useAppSelector((state) => state?.bookmarkedPlans?.list);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const innCodeBookmark: Bookmarkplans = bookmarkedPlanList.find((item: any) => item.innCode === innCode);
  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  const topSuggestedPlanList: any = useAppSelector((state) => state.suggestedPlans.topSuggestedPlansList);
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <>
      <Box
        sx={{
          backgroundColor: tokens.Background.General.Tertiary,
          borderRadius: isMobileScreen ? "0" : "12px",
          marginX: isMobileScreen ? "-16px" : "0",
          padding: "16px"
        }}
      >
        <Typography variant={"h4"} showBold color={tokens.Text.General.PrimaryHeadline}>
          Top Suggested Plans
        </Typography>
        <Box maxWidth={"450px"} marginY="16px">
          <Typography variant={"body2"} color={tokens.Text.General.Secondary}>
            These are the plans that we believe will really boost your results. However further down the page you can
            see other suggestions
          </Typography>
        </Box>
        {topSuggestedPlanList.map((item: any) => {
          return (
            <Item
              key={item.id}
              suggested={true}
              item={item}
              isBookmarked={bookmarkPlanIds.includes(item.id.toString())}
            ></Item>
          );
        })}
      </Box>
    </>
  );
}

export default TopSuggestedPlans;
